import { ReactElement } from 'react'
import { I18n } from 'common'
import { breakpoints } from '../../../../../src/theme/breakpoints'
import styled from 'styled-components'
import {
  VisibilityOff as VisibilityOffIcon,
  Visibility as VisibilityIcon,
} from '@mui/icons-material'

interface YourCostProps {
  showYourCost: boolean
  onClick: () => void
}

export const YourCost = (props: YourCostProps): ReactElement => {
  const { showYourCost, onClick } = props

  return (
    <Wrapper onClick={onClick}>
      {showYourCost ? <VisibilityIcon /> : <VisibilityOffIcon />}
      <Text name="yourCost" style={{ marginLeft: '5px', fontSize: '16px' }} />
    </Wrapper>
  )
}

const Text = styled(I18n)`
  margin-left: 5px;
  font-size: 16px;
  @media screen and (max-width: ${breakpoints.tablet}px) {
    margin-top: 2px;
    margin-left: 5px;
    font-size: 14px !important;
    align-self: flex-end;
  }
`

const Wrapper = styled.div`
  width: fit-content;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  text-transform: uppercase;
  font-weight: bold;
  font-family: Oswald, serif;

  @media screen and (max-width: ${breakpoints.tablet}px) {
    margin-top: 5px;
    font-size: 14px important!;
  }

  @media print {
    display: none;
  }
`
